export const getCommonState = state => state.common;
export const getActiveDrawer = state => getCommonState(state).activeDrawer;
export const getFetchNextAppointment = state => getCommonState(state).fetchNextAppointment;
